<template>
   <!-- "Filtered by:" row. Only shows when at least one filter is on -->
   <div v-if="chips.length" class="d-flex flex-wrap align-items-center gap-2 px-2 py-2 active-filters">
      <small class="sa-core-color">Filtered by:</small>

      <span
         v-for="chip in chips"
         :key="chip.key"
         class="badge rounded-pill bg-light text-dark d-inline-flex align-items-center gap-1 filter-chip"
      >
         <i v-if="chip.icon" :class="chip.icon"></i>
         {{ chip.label }}
         <button
            type="button"
            class="btn-close ms-1"
            :title="'Remove: ' + chip.label"
            @click="$emit('remove', chip.key)"
         ></button>
      </span>

      <button
         v-if="chips.length > 1"
         type="button"
         class="btn btn-link btn-sm p-0 sa-core-color"
         @click="$emit('clear')"
      >
         Clear all
      </button>
   </div>
</template>

<script>
// Shows the filters that are on, each with an × to remove it.
// chips: [{ key: "date", label: "This month (01/10/2026 – 31/10/2026)", icon: "fa fa-calendar" }]
export default {
   name: "ActiveFilters",
   props: {
      chips: { type: Array, default: () => [] },
   },
   emits: ["remove", "clear"],
};
</script>

<style scoped>
.active-filters {
   border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.filter-chip {
   font-size: 0.8rem;
   font-weight: 600;
   padding: 0.35rem 0.6rem;
}
.filter-chip .btn-close {
   width: 0.5em;
   height: 0.5em;
   padding: 0;
   cursor: pointer;
}
</style>